import axios from "axios";

// live
export const baseUrl = "https://api.thegreenmatter.com/";

// test
// export const baseUrl = "http://ec2-54-194-113-34.eu-west-1.compute.amazonaws.com:6047/";

export function getResource(path, onSuccess, onFail) {
    let requestData = {
        method: "get",
        url: baseUrl + path,
        headers: {},
    };

    axios(requestData)
        .then((res) => {
            onSuccess(res.data);
        })
        .catch((fail) => {
            onFail(fail.response);
        });
}
